/** A caught value's message, for a toast description or a captured error:
 *  an `Error`'s own message, otherwise its string form. */
export const errorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error)
